import { Directive, ElementRef, EventEmitter, NgZone, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[appLazyPreview]',
  standalone: true
})
export class LazyPreviewDirective implements OnInit, OnDestroy {
  @Output() previewVisible = new EventEmitter<void>();

  private observer?: IntersectionObserver;

  constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly zone: NgZone
  ) {}

  ngOnInit(): void {
    this.observer = new IntersectionObserver(
      entries => this.handleEntries(entries),
      { rootMargin: '150px' }
    );
    this.observer.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  private handleEntries(entries: IntersectionObserverEntry[]): void {
    if (!entries.some(entry => entry.isIntersecting)) {
      return;
    }

    this.observer?.disconnect();
    this.zone.run(() => this.previewVisible.emit());
  }
}
